import config from '../config'
import CoreServices from './coreServices'
import { HISTORY } from '../constants/services'
import axios from 'axios'

class GiftService extends CoreServices {
  async getGifts() {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/gifts`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data
      return data
    } catch (error) {
      return { error }
    }
  }

  async sendGift({ giftId, conversationId }) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/gifts/${giftId}?conversation=${conversationId}`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data
      return data
    } catch (error) {
      return error.response.data
    }
  }
}

export default new GiftService()
